import React, { useState } from 'react';
import { ChevronDown, Mail, Phone } from 'lucide-react';

const faqs = [
  {
    question: 'Hvordan registrerer jeg meg for Workout ON-tjenesten?',
    answer:
      'Det er raskt og enkelt å komme i gang. Klikk på "Fortsett"-knappen, skriv inn mobilnummeret ditt og tast inn PIN-koden du mottar via SMS. Abonnementet aktiveres umiddelbart etter bekreftelse.',
  },
  {
    question: 'Hvilke enheter og plattformer er kompatible med tjenesten?',
    answer:
      'Workout ON er designet for å fungere sømløst på alle enheter. Enten du bruker smarttelefon, nettbrett, laptop eller stasjonær PC – du får full tilgang til alt innhold. Ingen installasjon nødvendig.',
  },
  {
    question: 'Hva koster abonnementet?',
    answer:
      'Abonnementet koster kr 39,- per uke. Beløpet belastes telefonregningen din eller trekkes fra forhåndsbetalt saldo. Du kan avslutte når som helst uten bindingstid.',
  },
  {
    question: 'Hvordan kan jeg avslutte abonnementet?',
    answer:
      'Det finnes fire enkle måter å avslutte på: (1) Send SMS: Send WO STOPP til 2210 – du meldes av umiddelbart. (2) E-post: Send mobilnummeret ditt til no@workout-on.com. (3) Telefon: Ring kundeservice på +4721955881. Abonnementet avsluttes i henhold til gjeldende faktureringsperiode.',
  },
  {
    question: 'Er ikke spørsmålet mitt blant de vanlige spørsmålene?',
    answer:
      'Ingen bekymringer! Du kan sende spørsmålet ditt direkte til no@workout-on.com, ringe +4721955881, eller bruke kontaktskjemaet nedenfor. Kundeserviceteamet vårt er klart til å hjelpe deg.',
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section id="faq" className="py-24 bg-dark">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-primary-light text-sm font-semibold uppercase tracking-widest">FAQ</span>
          <h2 className="mt-3 text-4xl lg:text-5xl font-black text-white font-heading">
            Vanlige{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-light to-accent">
              spørsmål
            </span>
          </h2>
          <p className="mt-4 text-slate-400">
            Finn svar på de vanligste spørsmålene om Workout ON.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-border-dark rounded-xl overflow-hidden transition-all duration-200 hover:border-primary/30"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-6 py-5 text-left bg-card-dark hover:bg-card-dark/80 transition-colors"
              >
                <span className="text-base font-semibold text-white pr-4">{faq.question}</span>
                <ChevronDown
                  className={`w-5 h-5 text-primary-light shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>
              {openIndex === index && (
                <div className="px-6 py-5 bg-dark border-t border-border-dark">
                  <p className="text-slate-400 leading-relaxed text-sm">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div id="kontakt" className="mt-16 bg-card-dark border border-border-dark rounded-2xl p-8 text-center">
          <h3 className="text-xl font-bold text-white mb-3">Fant du ikke svaret?</h3>
          <p className="text-slate-400 mb-6 text-sm">
            Kontakt oss direkte – vi er her for å hjelpe deg.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <a
              href="mailto:no@workout-on.com"
              className="flex items-center justify-center gap-2 bg-primary/10 border border-primary/30 hover:border-primary/60 text-primary-light px-6 py-3 rounded-xl text-sm font-medium transition-all"
            >
              <Mail className="w-4 h-4" />
              no@workout-on.com
            </a>
            <a
              href="tel:+4721955881"
              className="flex items-center justify-center gap-2 bg-primary/10 border border-primary/30 hover:border-primary/60 text-primary-light px-6 py-3 rounded-xl text-sm font-medium transition-all"
            >
              <Phone className="w-4 h-4" />
              +47 21 95 58 81
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
